import { CommonApiErrorDetailsModel } from './common-api-error-details.model';

export class CommonApiErrorModel {
    status: string;
    correlationId: string;
    details: CommonApiErrorDetailsModel[];

    public static isCommonApiErrorModel(error: unknown): error is CommonApiErrorModel {
        const possibleErrorModel = error as CommonApiErrorModel;

        function isTypeOrNull(object: unknown, type: string): boolean {
            return (object === null || typeof object === type);
        }

        return typeof possibleErrorModel === 'object'
            && possibleErrorModel !== null
            && isTypeOrNull(possibleErrorModel.status, 'string')
            && isTypeOrNull(possibleErrorModel.correlationId, 'string')
            && isTypeOrNull(possibleErrorModel.details, 'object');
    }

    public static getErrorDetail(error: unknown): CommonApiErrorDetailsModel {
        if (!this.isCommonApiErrorModel(error)) {
            return null;
        }
        return (error as CommonApiErrorModel).details?.[0];
    }
}

